<template>
    <div ref="wrapper" :class="wrapperClass">
        <div v-show="showRefresh" ref="refreshItem" :class="{ 'refreshItemHorizon': ifScrollHorizon, 'refreshItemVertical': !ifScrollHorizon }">
            {{ refreshDescription }}
        </div>
        <slot></slot>
        <div v-show="showLoading" ref="loadingItem" :class="{ 'loadingItemHorizon': ifScrollHorizon, 'loadingItemVertical': !ifScrollHorizon }">
            {{ loadingDescription }}
        </div>
    </div>
</template>

<script>
/**
 * 
 */
const REFRESH_ITEM_STATE_SLIDING = 0
const REFRESH_ITEM_STATE_IDLE = 1
const REFRESH_ITEM_STATE_MOVING = 2

//
const REFRESH_ITEM_REMAIN_DURATION = 1000;

//
const SCROLL_VERTICAL_REFRESH_ITEM_THRESHOULD_REFRESH_HEIGHT = 50;
const SCROLL_VERTICAL_REFRESH_ITEM_THRESHOULD_REFRESH_MAX_HEIGHT = 80;

//
const SCROLL_HORIZON_REFRESH_ITEM_THRESHOULD_REFRESH_WIDTH = 40;
const SCROLL_HORIZON_REFRESH_ITEM_THRESHOULD_REFRESH_MAX_WIDTH = 80;

/**
 * 
 */
const LOADING_ITEM_STATE_HIDDEN = 1
const LOADING_ITEM_STATE_SHOW = 2

//
const LOADING_ITEM_REMAIN_DURATION = 1000;

//
const SCROLL_VERTICAL_LOADING_ITEM_THRESHOULD_LOADING_HEIGHT = 80;

//
const SCROLL_HORIZON_LOADING_ITEM_THRESHOULD_LOADING_WIDTH = 60;


export default {
    name: "BaseScroll",

    props: {
        ifScrollHorizon: {
            type: Boolean,
            default: false,
        },

        showScroll: {
            type: Boolean,
            default: false,
        },

        showRefresh: {
            type: Boolean,
            default: false,
        },

        showLoading: {
            type: Boolean,
            default: true,
        },
    },

    data() {
        return {
            //
            wrapperClass: '',

            //
            originScrollTop: 0,
            originScrollLeft: 0,

            //
            refreshDescription: '',
            refreshItemState: REFRESH_ITEM_STATE_IDLE,
            refreshItemStartPosition: null,

            //
            loadingItemState: LOADING_ITEM_STATE_HIDDEN,
            loadingDescription: '加载中',
        }
    },

    created()
    {
        
    },

    mounted()
    {
        //
        if(this.ifScrollHorizon)
        {
            //
            this.wrapperClass = 'wrapperHorizon';

            //
            if(this.showScroll)
            {
                this.$refs.wrapper.style['overflow-x'] = 'scroll';
            }
        }
        else
        {
            //
            this.wrapperClass = 'wrapperVertical';

            //
            if(this.showScroll)
            {
                this.$refs.wrapper.style['overflow-y'] = 'scroll';
            }
        }

        //
        this.$refs.wrapper.addEventListener("scroll", this.scrollListener);

        //
        if(this.showRefresh)
        {
            if(this.ifScrollHorizon)
            {
                this.initScrollAnimation(SCROLL_HORIZON_REFRESH_ITEM_THRESHOULD_REFRESH_WIDTH, SCROLL_HORIZON_REFRESH_ITEM_THRESHOULD_REFRESH_MAX_WIDTH)
            }
            else
            {
                this.initScrollAnimation(SCROLL_VERTICAL_REFRESH_ITEM_THRESHOULD_REFRESH_HEIGHT, SCROLL_VERTICAL_REFRESH_ITEM_THRESHOULD_REFRESH_MAX_HEIGHT)
            }
        }
    },

    methods: {
        //
        initScrollAnimation(refreshDistanceThreshould, refreshDistanceMaxThreshould) {
            //
            this.$refs.wrapper.addEventListener(
                'touchstart',
                (e) => {
                    
                },
                {}
            )

            this.$refs.wrapper.addEventListener(
                'touchend',
                (e) => {
                    //
                    if (this.refreshItemState == REFRESH_ITEM_STATE_SLIDING) {
                        return
                    }

                    //
                    this.refreshItemState = REFRESH_ITEM_STATE_SLIDING

                    //
                    if((!this.ifScrollHorizon && this.$refs.refreshItem.getClientRects()[0].height < refreshDistanceThreshould) || 
                    (this.ifScrollHorizon && this.$refs.refreshItem.getClientRects()[0].width < refreshDistanceThreshould))
                    {
                        //
                        if(this.ifScrollHorizon)
                        {
                            this.$refs.refreshItem.style.width = '0px'
                        }
                        else
                        {
                            this.$refs.refreshItem.style.height = '0px'
                        }
                        this.$refs.refreshItem.style.transition = 'all 0.5s'

                        //
                        this.$nextTick(() => {
                            //
                            this.$refs.refreshItem.style.transition = 'all 0s'

                            //
                            this.refreshItemState = REFRESH_ITEM_STATE_IDLE;
                        })
                    }
                    else
                    {
                        //
                        this.refreshDescription = '刷新中'

                        //
                        this.$emit("pullingDown");

                        //
                        setTimeout(() => {
                            if(this.ifScrollHorizon)
                            {
                                this.$refs.refreshItem.style.width = '0px'
                            }
                            else
                            {
                                this.$refs.refreshItem.style.height = '0px'
                            }
                            this.$refs.refreshItem.style.transition = 'all 0.5s'

                            //
                            this.refreshDescription = '刷新结束';

                            this.$nextTick(() => {
                                //
                                this.$refs.refreshItem.style.transition = 'all 0s'

                                //
                                this.refreshItemState = REFRESH_ITEM_STATE_IDLE;
                            })
                        }, REFRESH_ITEM_REMAIN_DURATION);
                    }
                },
                {}
            )

            this.$refs.wrapper.addEventListener(
                'touchmove',
                (e) => {
                    //
                    if (this.refreshItemState == REFRESH_ITEM_STATE_SLIDING) {
                        return
                    }
                    
                    // scroll to top and not trigger refreshItem move 
                    if(((!this.ifScrollHorizon && this.$refs.wrapper.scrollTop <= 0) ||
                    (this.ifScrollHorizon && this.$refs.wrapper.scrollLeft <= 0)) && 
                    this.refreshItemState == REFRESH_ITEM_STATE_IDLE)
                    {
                        //
                        this.refreshItemState = REFRESH_ITEM_STATE_MOVING;
                        
                        //
                        if(this.ifScrollHorizon)
                        {
                            this.refreshItemStartPosition = e.changedTouches[0].pageX;
                        }
                        else
                        {
                            this.refreshItemStartPosition = e.changedTouches[0].pageY;
                        }
                        

                        //
                        return;
                    }

                    //
                    if(this.refreshItemState == REFRESH_ITEM_STATE_IDLE)
                    {
                        return;
                    }

                    //
                    let touchRunDistance;
                    if(this.ifScrollHorizon)
                    {
                        touchRunDistance = e.changedTouches[0].pageX - this.refreshItemStartPosition;
                    }
                    else
                    {
                        touchRunDistance = e.changedTouches[0].pageY - this.refreshItemStartPosition;
                    }

                    //
                    if(touchRunDistance < 0)
                    {
                        return;
                    }

                    //
                    if(touchRunDistance >= refreshDistanceThreshould)
                    {
                        this.refreshDescription = '释放刷新'
                    }
                    else
                    {
                        this.refreshDescription = '刷新'
                    }

                    //
                    if(touchRunDistance <= refreshDistanceMaxThreshould)
                    {
                        //
                        if(this.ifScrollHorizon)
                        {
                            this.$refs.refreshItem.style.width = `${touchRunDistance}px`
                        }
                        else
                        {
                            this.$refs.refreshItem.style.height = `${touchRunDistance}px`
                        }
                        
                    }
                },
                {}
            )
        },

        scrollVerticalListener()
        {
            if(this.$refs.wrapper.scrollHeight - (this.$refs.wrapper.scrollTop + this.$refs.wrapper.getClientRects()[0].height) < 1)
            {
                if(this.showLoading)
                {
                    //
                    this.$emit("pullingUp");

                    //
                    if(this.loadingItemState == LOADING_ITEM_STATE_HIDDEN && this.$refs.wrapper.scrollTop > this.originScrollTop)
                    {
                        //
                        this.loadingItemState = LOADING_ITEM_STATE_SHOW

                        //
                        this.$refs.loadingItem.style.height = `${SCROLL_VERTICAL_LOADING_ITEM_THRESHOULD_LOADING_HEIGHT}px`;

                        //
                        this.$refs.loadingItem.style.transition = 'all 0.3s';
                        
                        //
                        setTimeout(() => {
                            //
                            this.$refs.loadingItem.style.height = '0px';

                            //
                            setTimeout(() => {
                                this.loadingItemState = LOADING_ITEM_STATE_HIDDEN;
                            }, 500)
                        }, LOADING_ITEM_REMAIN_DURATION);
                    }
                }
            }

            //
            if(this.$refs.wrapper.scrollTop > this.originScrollTop)
            {
                this.$emit("scrollTop", this.$refs.wrapper.scrollTop, 'up')
            }
            else
            {
                this.$emit("scrollTop", this.$refs.wrapper.scrollTop, 'down')
            }
            
            //
            this.originScrollTop = this.$refs.wrapper.scrollTop;
        },

        scrollHorizonListener()
        {
            if(this.$refs.wrapper.scrollWidth - (this.$refs.wrapper.scrollLeft + this.$refs.wrapper.getClientRects()[0].width) < 1)
            {
                
                if(this.showLoading)
                {
                    //
                    this.$emit("pullingUp");

                    //
                    if(this.loadingItemState == LOADING_ITEM_STATE_HIDDEN && this.$refs.wrapper.scrollLeft > this.originScrollLeft)
                    {
                        //
                        this.loadingItemState = LOADING_ITEM_STATE_SHOW

                        //
                        this.$refs.loadingItem.style.width = `${SCROLL_HORIZON_LOADING_ITEM_THRESHOULD_LOADING_WIDTH}px`;

                        //
                        this.$refs.loadingItem.style.transition = 'all 0.3s';

                        //
                        setTimeout(() => {
                            //
                            this.$refs.loadingItem.style.width = '0px';

                            //
                            setTimeout(() => {
                                this.loadingItemState = LOADING_ITEM_STATE_HIDDEN;
                            }, 500)
                        }, LOADING_ITEM_REMAIN_DURATION);
                    }
                }
            }

            //
            if(this.$refs.wrapper.scrollLeft > this.originScrollLeft)
            {
                this.$emit("scrollLeft", this.$refs.wrapper.scrollLeft, 'left')
            }
            else
            {
                this.$emit("scrollLeft", this.$refs.wrapper.scrollLeft, 'right')
            }

            //
            this.originScrollLeft = this.$refs.wrapper.scrollLeft;
        },

        scrollListener()
        {
            //
            if(this.ifScrollHorizon)
            {
                this.scrollHorizonListener();
            }
            else
            {
                //
                this.scrollVerticalListener();
            }
        },
    }
}

</script>

<style lang="scss" scoped>

.wrapperVertical {
    overflow-y: auto;
    overflow-x: hidden;
    -webkit-overflow-scrolling: touch;
    font-size: $fontSizeContent;
}

.wrapperHorizon {
    white-space: nowrap;
    overflow-x: auto;
    overflow-y: hidden;
    -webkit-overflow-scrolling: touch;
    font-size: $fontSizeContent;
}

//
.refreshItem
{
    overflow: hidden;
    display: flex;
    align-items: center;
    justify-content: center;
    font-weight: 800;
}

.refreshItemVertical {
    @extend .refreshItem;

    width: 100%;
    height: 0px;
}

.refreshItemHorizon {
    @extend .refreshItem;

    height: 100%;
    vertical-align: middle;
    text-align: center;
    display: inline-block;
    width: 0px;

}

//
.loadingItem
{
    overflow: hidden;
    display: flex;
    align-items: center;
    justify-content: center;
    font-weight: 800;
}

.loadingItemVertical {
    @extend .loadingItem;

    width: 100%;
    height: 0px;
}

.loadingItemHorizon {
    @extend .loadingItem;

    height: 100%;
    vertical-align: middle;
    text-align: center;
    display: inline-block;
    width: 0px;
}
</style>